/***************************************************************************************
 * FileName      : IntroAnimationOverlay.tsx
 * Description   : 진입 애니메이션 오버레이 컴포넌트
 *                 - 진입 애니메이션 재생 중 화면 우측 하단에 "건너뛰기" 버튼 표시
 *                 - 사용자가 건너뛰기 클릭 시 onSkip 콜백 호출
 * Author        : (주)한국공학기술연구원 박은정
 * Created Date  : 2026.02.12
 * Modified Date :
 * Reference     : packages/scjeil-smart_ict_lab-app/assets/json/matterport/intro-animation.json
 ***************************************************************************************/

import React from 'react';

interface Props {
  isVisible: boolean;
  onSkip: () => void;
}

// 2026.02.12 : 박은정 : 진입 애니메이션 중 표시되는 건너뛰기 버튼 오버레이
export const IntroAnimationOverlay: React.FC<Props> = ({ isVisible, onSkip }) => {
  if (!isVisible) return null;

  return (
    <div className="intro-anim-overlay">
      <button className="intro-anim-overlay__skip-btn" onClick={onSkip}>
        건너뛰기
        {/* 2026.02.12 : 박은정 : 건너뛰기 아이콘 (skip forward) */}
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="5 4 15 12 5 20 5 4" />
          <line x1="19" y1="5" x2="19" y2="19" />
        </svg>
      </button>
    </div>
  );
};

